module.exports = __webpack_public_path__ + "static/img/battle-monsters@3x.7cd8d3e0.png";